import TextareaAutosize from "react-textarea-autosize";
import { styled, CSSProperties } from "styled-components";

export const textareaFocusStyles: CSSProperties = {
  border: "1px solid rgba(115,115,118,0.8)",
};

export const Container = styled(TextareaAutosize)(({ theme }) => {
  return {
    width: "calc(100% - 42px)",
    borderRadius: `${theme.radii[1]} 0 0 ${theme.radii[1]}`,
    height: "42px",
    borderRightWidth: 0,
    fontSize: theme.fontSizes["2"],
    padding: `9px ${theme.space[4]} 10px`,
    color: theme.colors.black,
    boxSizing: "border-box",
    border: "1px solid rgba(115,115,118,0.3)",
    backgroundColor: theme.colors.white,
    boxShadow: `0 1px 12px ${theme.shadows[2]}`,
    transition: "border-color 250ms",
    resize: "none",
    fontFamily: theme.fonts.default,

    "&:focus": {
      ...textareaFocusStyles,
      outline: "none",
    },

    "&::placeholder": {
      color: theme.colors.grayDark,
    },
  };
});
